import { render, staticRenderFns } from "./file-upload.vue?vue&type=template&id=31d5f0d2&scoped=true&lang=pug"
import script from "./file-upload.js?vue&type=script&lang=js&external"
export * from "./file-upload.js?vue&type=script&lang=js&external"
import style0 from "./file-upload.vue?vue&type=style&index=0&id=31d5f0d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31d5f0d2",
  null
  
)

export default component.exports